/*@flow*/
import { segmentsIntersect } from './util';

// Polylines with 2 sides can only intersect in cases where points are collinear (we don't support detecting these).
// Cannot have intersection when < 3 line segments (< 4 points)
function tooFewPointsForIntersection(poly, extraPoints) {
  let points = getProjectedPoints(poly),
    len = points ? points.length : 0;
  // Increment length by extraPoints if present
  len += extraPoints || 0;

  return !points || len <= 3;
}

// Checks a line segment intersections with any line segments before its predecessor.
// Don't need to check the predecessor as will never intersect.
function lineSegmentsIntersectsRange(poly, p, p1, maxIndex, minIndex) {
  let points = getProjectedPoints(poly);

  minIndex = minIndex || 0;

  // Check all previous line segments (beside the immediately previous) for intersections
  for (let j = maxIndex; j > minIndex; j--) {
    let p2 = points[j - 1];
    let p3 = points[j];

    if (segmentsIntersect(p, p1, p2, p3)) {
      return true;
    }
  }

  return false;
}

function getProjectedPoints(poly: Leaflet$Polygon | Leaflet$Polyline) {
  let points = [];
  let _shape = poly._defaultShape();

  for (let i = 0; i < _shape.length; i++) {
    points.push(poly._map.latLngToLayerPoint(_shape[i]));
  }
  return points;
}

// @method intersects(): boolean
// Check to see if this polyline has any linesegments that intersect.
// NOTE: does not support detecting intersection for degenerate cases.
function polylineIntersects(poly) {
  let points = getProjectedPoints(poly);
  let len = points ? points.length : 0;

  if (tooFewPointsForIntersection(poly)) {
    return false;
  }

  for (let i = len - 1; i >= 3; i--) {
    let p = points[i - 1];
    let p1 = points[i];

    if (lineSegmentsIntersectsRange(poly, p, p1, i - 2)) {
      return true;
    }
  }

  return false;
}

// @method intersects(): boolean
// Checks a polygon for any intersecting line segments. Ignores holes.
export function polygonIntersects(poly: Leaflet$Polygon | Leaflet$Polyline): boolean {
  let points = getProjectedPoints(poly);

  if (tooFewPointsForIntersection(poly)) {
    return false;
  }

  // If already found an intersection don't need to check for any more.
  if (polylineIntersects(poly)) {
    return true;
  }

  let len = points.length;
  let firstPoint = points[0];
  let lastPoint = points[len - 1];
  let maxIndex = len - 2;

  // Check the line segment between last and first point. Don't need to check the first line segment (minIndex = 1)
  return lineSegmentsIntersectsRange(poly, lastPoint, firstPoint, maxIndex, 1);
}
